import React, { FC, useState, useEffect } from 'react'

// Styles
import { makeStyles, Box, Typography, Link } from '@material-ui/core'

// Images
import imageOutdatedBrowser from 'assets/outdated-warning.svg'

export const OutdatedBrowser: FC = () => {
  const classes = useStyles()

  const [browserOutdated, setBrowserOutdated] = useState<boolean>(false)

  useEffect(() => {
    function isIE() {
      const ua = navigator.userAgent

      /* MSIE used to detect old browsers and Trident used to newer ones*/
      return ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1
    }

    function isOutdated() {
      // References:
      // https://caniuse.com/mdn-api_css
      // https://developer.mozilla.org/en-US/docs/Web/API/CSS
      if (!CSS) {
        return true
      } else if (typeof CSS !== 'function' && typeof CSS !== 'object') {
        return true
      } else if (CSS.supports('display', 'grid') === false) {
        return true
      } else {
        return false
      }
    }

    if (isIE() || isOutdated()) {
      setBrowserOutdated(true)
    }
  }, [])

  if (browserOutdated) {
    return (
      <Box className={classes.root}>
        <img className={classes.image} src={imageOutdatedBrowser} alt='Outdated browser' width='64' />
        <Typography component='h1' variant='h2' color='textPrimary' gutterBottom>
          Your browser version
          <br />
          is not supported
        </Typography>
        <Typography component='p' variant='body2' color='textPrimary'>
          Please use{' '}
          <Link href='https://outdatedbrowser.com' variant='body2' target='_blank' rel='noopener noreferrer'>
            another browser
          </Link>{' '}
          (e.g. Chrome, Safari, Edge, Firefox)
          <br /> to continue using the experience.
        </Typography>
      </Box>
    )
  } else {
    return null
  }
}

const useStyles = makeStyles({
  root: {
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
    userSelect: 'none',

    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    position: 'fixed',
    'z-index': '10000000',

    display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',

    backgroundColor: '#ffffff',
    animation: '$fadeInOpacity 0.4s'
  },
  image: {
    marginBottom: '20px'
  },
  '@keyframes fadeInOpacity': {
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  }
})
